{
  "colorFormat": "カラーフォーマット",
  "hex": "16 進数",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
